import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export function plainTextLength(value: string | Nullish) {
  if (isNil(value)) {
    return 0;
  }

  if (!value.trim().startsWith('<')) {
    return value.length;
  }

  const parser = new DOMParser();
  const documentNode = parser.parseFromString(value, 'text/html');

  return (documentNode.body.textContent ?? '').replace(/\u00a0/g, ' ').length;
}
